import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadNotesUpdateAtom = createMutationAtomFactory(
  'trade.loadNotesUpdate',
  (params: {
    id: string;
    recyclerInternalNotes: string;
    recyclerExternalNotes: string;
    customerInternalNotes: string;
    customerExternalNotes: string;
  }) => ({
    tradeLoadUpdate: {
      __args: {
        id: params.id,
        input: {
          recyclerInternalNotes: params.recyclerInternalNotes,
          recyclerExternalNotes: params.recyclerExternalNotes,
          customerInternalNotes: params.customerInternalNotes,
          customerExternalNotes: params.customerExternalNotes,
        },
      },
      load: {
        id: true,
      },
    },
  }),
  { showLoadingOverlay: false },
);
